import { render, staticRenderFns } from "./LearningRecord.vue?vue&type=template&id=5f2149a0&"
import script from "./LearningRecord.vue?vue&type=script&lang=js&"
export * from "./LearningRecord.vue?vue&type=script&lang=js&"
import style0 from "./LearningRecord.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports